import React from "react";
import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Reveal";

const PageHero = ({ eyebrow, title, intro, image }) => (
  <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0 -z-10">
      {image && (
        <>
          <img src={image} alt="" className="h-full w-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0 bg-[#1A2E24]/70" />
        </>
      )}
      {!image && <div className="absolute inset-0 bg-[#EAE5D9]" />}
    </div>
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        {eyebrow && <Eyebrow dark={!!image}>{eyebrow}</Eyebrow>}
        <h1 className={`mt-5 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl ${image ? "text-white" : "text-[#1A2E24]"}`}>
          {title}
        </h1>
        {intro && (
          <p className={`mt-6 text-lg leading-relaxed max-w-2xl ${image ? "text-[#EAE5D9]" : "text-[#3B5245]"}`}>
            {intro}
          </p>
        )}
      </motion.div>
    </div>
  </section>
);

export default PageHero;
